/**
 * Message i18n helpers
 *
 * Server-driven in-app messages carry an `i18nKey` (e.g., "messages.forceUpdate").
 * This module resolves the full translation keys for title, body, and action.
 *
 * This is one of the rare cases where dynamic i18n keys are necessary —
 * the server controls which message to show. We use i18n.t() with
 * defaultValue to ensure graceful degradation if a key is missing.
 */

import i18n from 'i18next';

export interface MessageTexts {
  title: string;
  body: string;
  action: string;
}

/**
 * Resolve translated title, body, and action for an in-app message.
 * Returns empty string for missing translations.
 */
export function resolveMessageTexts(i18nKey: string): MessageTexts {
  // Use the i18next instance directly (not the typed hook) since message
  // keys are server-driven and intentionally dynamic.
  return {
    title: i18n.t(`${i18nKey}.title`, { defaultValue: '' }) as string,
    body: i18n.t(`${i18nKey}.body`, { defaultValue: '' }) as string,
    action: i18n.t(`${i18nKey}.action`, { defaultValue: '' }) as string,
  };
}
